export const introSteps = (step: any, userResponse: any, history: any) => {

  if(userResponse === 'Técnicas de manejo de la ansiedad de los padres'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'main',
    }
  }
  if(userResponse === 'Preguntas frecuentes de los padres'){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'parents',
    }
  }

  if(userResponse === 'Ideas para distracción'){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'distraction',
    }
  }

  if(userResponse === 'Precauciones de alimentos y bebidas'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'food',
    }
  }

  if(userResponse === 'Proceso de inducción'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'induction',
    }
  }

  if(userResponse === 'Consejos en la sala de recuperación'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'recovery',
    }
  }

  if(userResponse === 'Qué esperar en casa'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'home',
    }
  }

  if(userResponse === 'Identificar el dolor de su hijo en casa'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'pain',
    }
  }

  if(userResponse === 'Cambiar/cancelar el día de la cirugía del niño'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'dateOfSurgery',
    }
  }

  if(userResponse === 'Comunicarse con el proveedor de atención médica de su hijo'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'contactHealthProvider',
    }
  }

  if(userResponse ==='Contactar al equipo L-WebTIPS'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'contactResearch',
    }
  }

 
  return {
    purpose: 'specify field',
    catchAll: true,
  }
    
}

export const mainFlowSteps = (step: any, userResponse: any, history: any) => {
  if(step === 0){ 
    return{
        purpose: 'specify field',
        message: `¿Le gustaría aprender más sobre cómo sentirse tranquilo antes de la cirugía de su hijo?`,
        waitForAnswer: true,
        options: [
          'Sí',
          'No',
        ],
      }
    }
    if(step === 1 && userResponse === 'No'){
      return {
        purpose: 'specify field',
        message: `¿Algo más con lo que pueda ayudar?`,
        options: [
        'Preguntas frecuentes de los padres',
        'Ideas para distracción',
        'Precauciones de alimentos y bebidas',
        'Proceso de inducción',
        'Consejos en la sala de recuperación',
        'Qué esperar en casa',
        'Identificar el dolor de su hijo en casa',
        'Cambiar/cancelar el día de la cirugía del niño',
        'Comunicarse con el proveedor de atención médica de su hijo',
        'Contactar al equipo L-WebTIPS',
      ],
      }
    }
    if(step === 1 && userResponse === 'Sí'){
      return [{
          purpose: 'specify field',
          message: `¡Fantástico! Sigamos.`,
        }, {
          purpose: 'specify field',
          message: 'Antes de la cirugía de su hijo, puede resultarle útil practicar técnicas de manejo de la ansiedad. Visite esta <a href="#" data-href="/contents/03">página</a> para obtener más información.',
        }, {
          purpose: 'specify field',
          delay: 5000,
          message: `¿Algo más con lo que pueda ayudar?`,
          options: [
          'Preguntas frecuentes de los padres',
          'Ideas para distracción',
          'Precauciones de alimentos y bebidas',
          'Proceso de inducción',
          'Consejos en la sala de recuperación',
          'Qué esperar en casa',
          'Identificar el dolor de su hijo en casa',
          'Cambiar/cancelar el día de la cirugía del niño',
          'Comunicarse con el proveedor de atención médica de su hijo',
          'Contactar al equipo L-WebTIPS',
        ],
        }]
      
    }
    if(userResponse === 'Técnicas de manejo de la ansiedad de los padres'
    ){
      return {
        purpose: 'specify field',
        message: ``,
        newFlow: 'main',
      }
    }
    if(userResponse === 'Preguntas frecuentes de los padres'){
      return {
        purpose: 'specify field',
        message: ``,
        newFlow: 'parents',
      }
    }
  
    if(userResponse === 'Ideas para distracción'){
      return {
        purpose: 'specify field',
        message: ``,
        newFlow: 'distraction',
      }
    }
  
    if(userResponse === 'Precauciones de alimentos y bebidas'
    ){
      return {
        purpose: 'specify field',
        message: ``,
        newFlow: 'food',
      }
    }
  
    if(userResponse === 'Proceso de inducción'
    ){
      return {
        purpose: 'specify field',
        message: ``,
        newFlow: 'induction',
      }
    }
  
    if(userResponse === 'Consejos en la sala de recuperación'
    ){
      return {
        purpose: 'specify field',
        message: ``,
        newFlow: 'recovery',
      }
    }
  
    if(userResponse === 'Qué esperar en casa'
    ){
      return {
        purpose: 'specify field',
        message: ``,
        newFlow: 'home',
      }
    }
  
    if(userResponse === 'Identificar el dolor de su hijo en casa'
    ){
      return {
        purpose: 'specify field',
        message: ``,
        newFlow: 'pain',
      }
    }
  
    if(userResponse === 'Cambiar/cancelar el día de la cirugía del niño'
    ){
      return {
        purpose: 'specify field',
        message: ``,
        newFlow: 'dateOfSurgery',
      }
    }
  
    if(userResponse === 'Comunicarse con el proveedor de atención médica de su hijo'
    ){
      return {
        purpose: 'specify field',
        message: ``,
        newFlow: 'contactHealthProvider',
      }
    }
  
    if(userResponse ==='Contactar al equipo L-WebTIPS'
    ){
      return {
        purpose: 'specify field',
        message: ``,
        newFlow: 'contactResearch',
      }
    }
    return {
      purpose: 'specify field',
      catchAll: true,
    }
    
}


export const secondaryFlow = (step: any, userResponse: any, history: any) => {
  if(step === 0){ 
    
      return {
        purpose: 'specify field',
        message: `¿Algo más con lo que pueda ayudar?`,
        options: [
        'Preguntas frecuentes de los padres',
        'Ideas para distracción',
        'Precauciones de alimentos y bebidas',
        'Proceso de inducción',
        'Consejos en la sala de recuperación',
        'Qué esperar en casa',
        'Identificar el dolor de su hijo en casa',
        'Cambiar/cancelar el día de la cirugía del niño',
        'Comunicarse con el proveedor de atención médica de su hijo',
        'Contactar al equipo L-WebTIPS',
      ],
      }
    }
    
    if(userResponse === 'Técnicas de manejo de la ansiedad de los padres'
    ){
      return {
        purpose: 'specify field',
        message: ``,
        newFlow: 'main',
      }
    }
    if(userResponse === 'Preguntas frecuentes de los padres'){
      return {
        purpose: 'specify field',
        message: ``,
        newFlow: 'parents',
      }
    }
  
    if(userResponse === 'Ideas para distracción'){
      return {
        purpose: 'specify field',
        message: ``,
        newFlow: 'distraction',
      }
    }
  
    if(userResponse === 'Precauciones de alimentos y bebidas'
    ){
      return {
        purpose: 'specify field',
        message: ``,
        newFlow: 'food',
      }
    }
  
    if(userResponse === 'Proceso de inducción'
    ){
      return {
        purpose: 'specify field',
        message: ``,
        newFlow: 'induction',
      }
    }
  
    if(userResponse === 'Consejos en la sala de recuperación'
    ){
      return {
        purpose: 'specify field',
        message: ``,
        newFlow: 'recovery',
      }
    }
  
    if(userResponse === 'Qué esperar en casa'
    ){
      return {
        purpose: 'specify field',
        message: ``,
        newFlow: 'home',
      }
    }
  
    if(userResponse === 'Identificar el dolor de su hijo en casa'
    ){
      return {
        purpose: 'specify field',
        message: ``,
        newFlow: 'pain',
      }
    }
  
    if(userResponse === 'Cambiar/cancelar el día de la cirugía del niño'
    ){
      return {
        purpose: 'specify field',
        message: ``,
        newFlow: 'dateOfSurgery',
      }
    }
  
    if(userResponse === 'Comunicarse con el proveedor de atención médica de su hijo'
    ){
      return {
        purpose: 'specify field',
        message: ``,
        newFlow: 'contactHealthProvider',
      }
    }
  
    if(userResponse ==='Contactar al equipo L-WebTIPS'
    ){
      return {
        purpose: 'specify field',
        message: ``,
        newFlow: 'contactResearch',
      }
    }
    return {
      purpose: 'specify field',
      catchAll: true,
    }
    
}

export const parentsFaqFlow = (step: any, userResponse: any) => {
  if(step === 0){
    return {
      message: '¿Le gustaría obtener más información sobre algunas preguntas frecuentes que los padres tienen antes de la cirugía de su hijo?',
      options: [
        'Sí',
        'No',
      ],
    }
  }
  if(step === 1 && userResponse === 'No'){
    return {
      purpose: 'specify field',
      message: `¿Algo más con lo que pueda ayudar?`,
      options: [
        'Técnicas de manejo de la ansiedad de los padres',
      'Ideas para distracción',
      'Precauciones de alimentos y bebidas',
      'Proceso de inducción',
      'Consejos en la sala de recuperación',
      'Qué esperar en casa',
      'Identificar el dolor de su hijo en casa',
      'Cambiar/cancelar el día de la cirugía del niño',
      'Comunicarse con el proveedor de atención médica de su hijo',
      'Contactar al equipo L-WebTIPS'],
    }
  }
  if(step === 1 && userResponse === 'Sí'){
    return [{
        purpose: 'specify field',
        message: `¡Lo tienes! 👍`,
      }, {
        purpose: 'specify field',
        message: `A continuación, se presentan algunas preguntas comunes que los padres pueden tener antes de la cirugía de su hijo. Puede hacer clic en cada video para obtener <a href="#" data-href="/contents/02">más información.</a>`,
      }, {
        purpose: 'specify field',
        delay: 5000,
        message: `¿Algo más con lo que pueda ayudar?`,
        options: [
          'Técnicas de manejo de la ansiedad de los padres',
          'Ideas para distracción',
          'Precauciones de alimentos y bebidas',
          'Proceso de inducción',
          'Consejos en la sala de recuperación',
          'Qué esperar en casa',
          'Identificar el dolor de su hijo en casa',
          'Cambiar/cancelar el día de la cirugía del niño',
          'Comunicarse con el proveedor de atención médica de su hijo',
          'Contactar al equipo L-WebTIPS',
      ],
      }]
    
  }
  if(userResponse === 'Técnicas de manejo de la ansiedad de los padres'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'main',
    }
  }
  if(userResponse === 'Preguntas frecuentes de los padres'){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'parents',
    }
  }

  if(userResponse === 'Ideas para distracción'){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'distraction',
    }
  }

  if(userResponse === 'Precauciones de alimentos y bebidas'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'food',
    }
  }

  if(userResponse === 'Proceso de inducción'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'induction',
    }
  }

  if(userResponse === 'Consejos en la sala de recuperación'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'recovery',
    }
  }

  if(userResponse === 'Qué esperar en casa'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'home',
    }
  }

  if(userResponse === 'Identificar el dolor de su hijo en casa'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'pain',
    }
  }

  if(userResponse === 'Cambiar/cancelar el día de la cirugía del niño'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'dateOfSurgery',
    }
  }

  if(userResponse === 'Comunicarse con el proveedor de atención médica de su hijo'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'contactHealthProvider',
    }
  }

  if(userResponse ==='Contactar al equipo L-WebTIPS'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'contactResearch',
    }
  }
  return {
    purpose: 'specify field',
    catchAll: true,
  }
}

export const distractionFlow = (step: any, userResponse: any) => {
  if(step === 0){
    return {
      message: 'Parece que le interesaría aprender a distraer a su hijo el día de la cirugía.',
      options: [
        'Sí',
        'No',
      ],
    }
  }
  if(userResponse === 'Hacer otra cosa'){
    return {
      purpose: 'specify field',
      message: `¿Algo más con lo que pueda ayudar?`,
      options: [
        'Técnicas de manejo de la ansiedad de los padres',
        'Preguntas frecuentes de los padres',
      'Precauciones de alimentos y bebidas',
      'Proceso de inducción',
      'Consejos en la sala de recuperación',
      'Qué esperar en casa',
      'Identificar el dolor de su hijo en casa',
      'Cambiar/cancelar el día de la cirugía del niño',
      'Comunicarse con el proveedor de atención médica de su hijo',
      'Contactar al equipo L-WebTIPS'],
    }
  
  }
  if(userResponse === 'No'){
    return {
      purpose: 'specify field',
      message: `¿Listo para seguir adelante?`,
      options: ['Hacer otra cosa'],
    }
  }

  
  if(step === 1 && userResponse === 'Sí'){
    return [{
        purpose: 'specify field',
        message: `¡Estoy reuniendo algunas ideas de distracción para usted!`,
      }, {
        purpose: 'specify field',
        message: `A continuación, aprenderá sobre algunos objetos de distracción e ideas para que traiga el día de la cirugía de su hijo. <a href="#" data-href="/contents/20"">más información</a>`,
        forceStep: 2,
      }, {
        message: '¿Le gustaría aprender un juego divertido que usted y su hijo puedan jugar el día de la cirugía?',
        options: [
          'Sí',
          'No',
        ],
      }]
  }
  
  if(step === 2 && userResponse === 'Sí'){
    return [{
        message: '¡Fenomenal! Este juego se llama Adivine que animal es. 🤔 Usted o su hijo pueden respirar en una máscara como su animal favorito. 🦁 ¡Me pregunto qué animal elegirás! Vea algunas instrucciones a continuación.',
      },
      {
        trackVideo: true,
        title: 'Juego Adivina qué Animal Es Chatbot',
        videoId: 'video3',
        message: '<video controls id="video3" style="width:200px" onPlay={() => {(window as any).trackVideo(window.location.pathname,"Juego Adivina qué Animal Es",this.duration,this.currentTime,\"play\")}} ><source src="https://s3-us-west-1.amazonaws.com/uci-images/video/p1/MG4_ES.mp4"></video>',
      }, {
        purpose: 'specify field',
        message: `¿Listo para seguir adelante?`,
        options: ['Hacer otra cosa'],
        delay: 5000,
      }]
  }
  if(userResponse === 'Técnicas de manejo de la ansiedad de los padres'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'main',
    }
  }
  if(userResponse === 'Preguntas frecuentes de los padres'){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'parents',
    }
  }

  if(userResponse === 'Ideas para distracción'){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'distraction',
    }
  }

  if(userResponse === 'Precauciones de alimentos y bebidas'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'food',
    }
  }

  if(userResponse === 'Proceso de inducción'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'induction',
    }
  }

  if(userResponse === 'Consejos en la sala de recuperación'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'recovery',
    }
  }

  if(userResponse === 'Qué esperar en casa'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'home',
    }
  }

  if(userResponse === 'Identificar el dolor de su hijo en casa'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'pain',
    }
  }

  if(userResponse === 'Cambiar/cancelar el día de la cirugía del niño'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'dateOfSurgery',
    }
  }

  if(userResponse === 'Comunicarse con el proveedor de atención médica de su hijo'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'contactHealthProvider',
    }
  }

  if(userResponse ==='Contactar al equipo L-WebTIPS'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'contactResearch',
    }
  }
  return {
    purpose: 'specify field',
    catchAll: true,
  }
}

export const foodFlow = (step: any, userResponse: any) => {
  if(step === 0){
    return {
      message: 'Parece que está interesado en aprender sobre alimentos y bebidas que su hijo no debería tener antes de la cirugía. ¿Es esto correcto?',
      options: [
        'Sí',
        'No',
      ],
    }
  }
  if(userResponse === 'Hacer otra cosa'){
    return {
      purpose: 'specify field',
      message: `¿Algo más con lo que pueda ayudar?`,
      options: [
        'Técnicas de manejo de la ansiedad de los padres',
        'Preguntas frecuentes de los padres',
        'Ideas para distracción',
        'Proceso de inducción',
        'Consejos en la sala de recuperación',
        'Qué esperar en casa',
        'Identificar el dolor de su hijo en casa',
        'Cambiar/cancelar el día de la cirugía del niño',
        'Comunicarse con el proveedor de atención médica de su hijo',
        'Contactar al equipo L-WebTIPS',
      ],
    }
  
  }
  if(userResponse === 'No'){
    return {
      purpose: 'specify field',
      message: `¿Listo para seguir adelante?`,
      options: ['Hacer otra cosa'],
    }
  }

  
  if(step === 1 && userResponse === 'Sí'){
    return [{
        purpose: 'specify field',
        message: `¡Fantástico! ¡De seguido lo tengo!`,
      }, {
        purpose: 'specify field',
        message: `Si bien estas recomendaciones pueden variar según el proveedor de atención médica de su hijo, aquí hay algunas recomendaciones comunes sobre alimentos🍕 y bebidas 🧃 para evitar. <a href="#" data-href="/contents/12">más información</a>`,
      },{
        delay: 5000,
        purpose: 'specify field',
        message: `¿Listo para seguir adelante?`,
        options: ['Hacer otra cosa'],
      }]
    
  }
  
  if(userResponse === 'Técnicas de manejo de la ansiedad de los padres'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'main',
    }
  }
  if(userResponse === 'Preguntas frecuentes de los padres'){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'parents',
    }
  }

  if(userResponse === 'Ideas para distracción'){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'distraction',
    }
  }

  if(userResponse === 'Precauciones de alimentos y bebidas'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'food',
    }
  }

  if(userResponse === 'Proceso de inducción'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'induction',
    }
  }

  if(userResponse === 'Consejos en la sala de recuperación'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'recovery',
    }
  }

  if(userResponse === 'Qué esperar en casa'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'home',
    }
  }

  if(userResponse === 'Identificar el dolor de su hijo en casa'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'pain',
    }
  }

  if(userResponse === 'Cambiar/cancelar el día de la cirugía del niño'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'dateOfSurgery',
    }
  }

  if(userResponse === 'Comunicarse con el proveedor de atención médica de su hijo'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'contactHealthProvider',
    }
  }

  if(userResponse ==='Contactar al equipo L-WebTIPS'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'contactResearch',
    }
  }
  return {
    purpose: 'specify field',
    catchAll: true,
  }
}

export const inductionFlow = (step: any, userResponse: any) => {

  if(step === 0){
    return {
      purpose: 'step4',
      message: '¿Está interesado en aprender qué es la inducción de la anestesia y cómo es ese proceso?',
      options: [
        'Sí',
        'No',
      ],
    }
  }
  if(step === 1 && userResponse === 'Sí'){
    return [{
      message: '¡Está en el lugar correcto!',
    },{
      purpose: 'step4',
      message: '¿Sabes qué es la medicación anestésica?',
      options: [
        'Sí',
        'No',
      ],
    }]
  }

  if(step === 1 && userResponse === 'No'){
    return {
      purpose: 'specify field',
      message: `¿Listo para seguir adelante?`,
      options: ['Hacer otra cosa'],
    }
  }

  if(step === 2 && userResponse === 'Sí'){
    return [{
      purpose: 'step4',
      message: 'Repasemos el proceso de inducción.',
    }, {
      message: 'La inducción es el proceso de darle a su hijo medicamentos anestésicos que hacen que su hijo se duerma.',
    }, {
      message: 'Esta <a href="#" data-href="/contents/24">página</a> proporciona algunos testimonios sobre padres que han pasado por la inducción con sus hijos.',
    }, {
      delay: 5000,
      purpose: 'step3',
      message: '¿Le gustaría ver un video mío (Billy Bot) explicando el proceso de quedarse dormido a su hijo?',
    }, {
      delay: 5000,
      purpose: 'step4',
      message: '<img src="https://uci-images.s3.us-west-1.amazonaws.com/images/chatbot/chatbot-billy.png"/>',
      options: [
        'Sí',
        'No',
      ],
    }]
  }

  if(step === 2 && userResponse === 'No'){
    return [{
      message: 'La anestesia es un medicamento que ayudará a su hijo a conciliar el sueño para la cirugía. Esto se administra a través de una máscara de anestesia. En el siguiente enlace, encontrará un ejemplo de una máscara de anestesia con la que su hijo puede familiarizarse.',
    },{
      
        message: '<img src="https://uci-images.s3.us-west-1.amazonaws.com/images/chatbot/chatbot-anna.png"/>',
    },{
      delay: 5000,
      purpose: 'step4',
      message: 'Repasemos el proceso de inducción.',
    }, {
      delay: 5000,
      message: 'La inducción es el proceso de darle a su hijo medicamentos anestésicos que hacen que su hijo se duerma.',
    }, {
      delay: 5000,
      message: 'Esta <a href="#" data-href="/contents/24">página</a> proporciona algunos testimonios sobre padres que han pasado por la inducción con sus hijos.',
    }, {
      purpose: 'step3',
      delay: 10000,
      message: '¿Le gustaría ver un video mío (Billy Bot) explicando el proceso de quedarse dormido a su hijo?',
    }, {
      delay: 10000,
      message: '<img src="https://uci-images.s3.us-west-1.amazonaws.com/images/chatbot/chatbot-billy.png"/>',
      options: [
        'Sí',
        'No',
      ],
    }]
  }
  
  if(userResponse === 'Hacer otra cosa'){
    return {
      purpose: 'specify field',
      message: `¿Algo más con lo que pueda ayudar?`,
      options: [
        'Técnicas de manejo de la ansiedad de los padres',
        'Preguntas frecuentes de los padres',
        'Ideas para distracción',
      'Consejos en la sala de recuperación',
      'Qué esperar en casa',
      'Identificar el dolor de su hijo en casa',
      'Cambiar/cancelar el día de la cirugía del niño',
      'Comunicarse con el proveedor de atención médica de su hijo',
      'Contactar al equipo L-WebTIPS'],
    }
  
  }
  if(userResponse === 'No'){
    return {
      purpose: 'specify field',
      message: `¿Listo para seguir adelante?`,
      options: ['Hacer otra cosa'],
    }
  }

  if(userResponse === 'Sí'){
    return [{
      message: '¡Fantástico! Haga clic aquí para verme explicar el proceso de quedarse dormido.',
    }, {
      trackVideo: true,
      title: 'Inducción Chatbot',
      videoId: 'video1',
      message: '<video controls id="video1" style="width:200px"><source src="https://s3-us-west-1.amazonaws.com/uci-images/video/kids/M1-HA_ES.mp4"/></video>',
    }, {
      delay: 5000,
      purpose: 'specify field',
      message: `¿Listo para seguir adelante?`,
      options: ['Hacer otra cosa'],
    }]
  }


  if(userResponse === 'Técnicas de manejo de la ansiedad de los padres'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'main',
    }
  }
  if(userResponse === 'Preguntas frecuentes de los padres'){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'parents',
    }
  }

  if(userResponse === 'Ideas para distracción'){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'distraction',
    }
  }

  if(userResponse === 'Precauciones de alimentos y bebidas'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'food',
    }
  }

  if(userResponse === 'Proceso de inducción'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'induction',
    }
  }

  if(userResponse === 'Consejos en la sala de recuperación'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'recovery',
    }
  }

  if(userResponse === 'Qué esperar en casa'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'home',
    }
  }

  if(userResponse === 'Identificar el dolor de su hijo en casa'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'pain',
    }
  }

  if(userResponse === 'Cambiar/cancelar el día de la cirugía del niño'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'dateOfSurgery',
    }
  }

  if(userResponse === 'Comunicarse con el proveedor de atención médica de su hijo'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'contactHealthProvider',
    }
  }

  if(userResponse ==='Contactar al equipo L-WebTIPS'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'contactResearch',
    }
  }
  return {
    purpose: 'specify field',
    catchAll: true,
  }

}

export const recoveryFlow = (step: any, userResponse: any) => {

  if(step === 0){
    return [{
      message: '¡Bien! ¡Sé todo sobre la sala de recuperación! <a href="#" data-href="/contents/31">más información</a>',
    },{
      message: 'Cuando termine la cirugía de su hijo, será transferido a la sala de recuperación. Su hijo puede dormir por algún tiempo. Las enfermeras controlarán su dolor y crearán un plan de manejo del dolor con usted para su hijo en casa. 🏠',
    }, {
      message: '¿Le gustaría ver la experiencia de un padre en la sala de recuperación?',
      options: [
        'Sí',
        'No',
      ],
    }]
  }
  if(userResponse === 'Hacer otra cosa'){
    return {
      purpose: 'specify field',
      message: `¿Algo más con lo que pueda ayudar?`,
      options: [
        'Técnicas de manejo de la ansiedad de los padres',
          'Preguntas frecuentes de los padres',
          'Ideas para distracción',
          'Precauciones de alimentos y bebidas',
          'Proceso de inducción',
          'Qué esperar en casa',
          'Identificar el dolor de su hijo en casa',
          'Cambiar/cancelar el día de la cirugía del niño',
          'Comunicarse con el proveedor de atención médica de su hijo',
          'Contactar al equipo L-WebTIPS',
      ],
    }
  
  }
  if(userResponse === 'No'){
    return {
      purpose: 'specify field',
      message: `¿Listo para seguir adelante?`,
      options: ['Hacer otra cosa'],
    }
  }
  if(userResponse === 'Sí' && step === 1){
    return [{
      purpose: 'specify field',
      message: `
      ¡Asombroso! Aquí hay un video testimonial de padres de la experiencia de la sala de recuperación.`,
    }, {
      trackVideo: true,
      title: 'Sala de recuperación Chatbot',
      videoId: 'video2',
      message: '<video controls id="video2" style="width:200px"><source src="https://uci-images.s3-us-west-1.amazonaws.com/video/p1/Recovery+room+-+What+parents+can+do+to+help+page.mp4"/></video>',
    }, {
      purpose: 'specify field',
      message: `¿Listo para seguir adelante?`,
      options: ['Hacer otra cosa'],
      delay: 5000,
    }]
  }



  if(userResponse === 'Técnicas de manejo de la ansiedad de los padres'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'main',
    }
  }
  if(userResponse === 'Preguntas frecuentes de los padres'){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'parents',
    }
  }

  if(userResponse === 'Ideas para distracción'){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'distraction',
    }
  }

  if(userResponse === 'Precauciones de alimentos y bebidas'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'food',
    }
  }

  if(userResponse === 'Proceso de inducción'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'induction',
    }
  }

  if(userResponse === 'Consejos en la sala de recuperación'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'recovery',
    }
  }

  if(userResponse === 'Qué esperar en casa'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'home',
    }
  }

  if(userResponse === 'Identificar el dolor de su hijo en casa'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'pain',
    }
  }

  if(userResponse === 'Cambiar/cancelar el día de la cirugía del niño'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'dateOfSurgery',
    }
  }

  if(userResponse === 'Comunicarse con el proveedor de atención médica de su hijo'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'contactHealthProvider',
    }
  }

  if(userResponse ==='Contactar al equipo L-WebTIPS'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'contactResearch',
    }
  }
  return {
    purpose: 'specify field',
    catchAll: true,
  }
}

export const homeFlow = (step: any, userResponse: any) => {



  if(step === 0){
    return {
      message: 'Parece que está interesado en aprender más sobre qué esperar en casa, ¿sí?',
      options: [
        'Sí',
        'No',
      ],
    }
  }
  
  if(userResponse === 'Hacer otra cosa'){
    return {
      purpose: 'specify field',
      message: `¿Algo más con lo que pueda ayudar?`,
      options: [
        'Técnicas de manejo de la ansiedad de los padres',
        'Preguntas frecuentes de los padres',
        'Ideas para distracción',
        'Precauciones de alimentos y bebidas',
        'Proceso de inducción',
        'Consejos en la sala de recuperación',
        'Identificar el dolor de su hijo en casa',
        'Cambiar/cancelar el día de la cirugía del niño',
        'Comunicarse con el proveedor de atención médica de su hijo',
        'Contactar al equipo L-WebTIPS',
      ],
    }
  
  }
  if(userResponse === 'No'){
    return {
      purpose: 'specify field',
      message: `¿Listo para seguir adelante?`,
      options: ['Hacer otra cosa'],
    }
  }

  if(userResponse === 'Sí' && step === 1){
    return [{
      purpose: 'specify field',
      message: `
      ¡Genial! Los padres pueden querer prepararse para el viaje de regreso a casa. 🏠.`,
    }, {
      message: 'Usted puede aprender más acerca de cómo se sentirá su hijo una vez que llegue a casa. <a href="#" data-href="/contents/39">más información</a>',
    }, {
      delay: 5000,
      purpose: 'specify field',
      message: `¿Listo para seguir adelante?`,
      options: ['Hacer otra cosa'],
    }]
  }


  if(userResponse === 'Técnicas de manejo de la ansiedad de los padres'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'main',
    }
  }
  if(userResponse === 'Preguntas frecuentes de los padres'){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'parents',
    }
  }

  if(userResponse === 'Ideas para distracción'){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'distraction',
    }
  }

  if(userResponse === 'Precauciones de alimentos y bebidas'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'food',
    }
  }

  if(userResponse === 'Proceso de inducción'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'induction',
    }
  }

  if(userResponse === 'Consejos en la sala de recuperación'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'recovery',
    }
  }

  if(userResponse === 'Qué esperar en casa'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'home',
    }
  }

  if(userResponse === 'Identificar el dolor de su hijo en casa'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'pain',
    }
  }

  if(userResponse === 'Cambiar/cancelar el día de la cirugía del niño'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'dateOfSurgery',
    }
  }

  if(userResponse === 'Comunicarse con el proveedor de atención médica de su hijo'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'contactHealthProvider',
    }
  }

  if(userResponse ==='Contactar al equipo L-WebTIPS'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'contactResearch',
    }
  }
  return {
    purpose: 'specify field',
    catchAll: true,
  }

}

export const painFlow = (step: any, userResponse: any) => {

  if(step === 0){
    return {
      message: '¿Le gustaría obtener más información sobre cómo controlar el dolor de su hijo en casa?',
      options: [
        'Sí',
        'No',
      ],
    }
  }

  if(step === 1 && userResponse === 'No'){
    return {
      message: '¿Está interesado en aprender a detectar el dolor de su hijo?',
      options: [
        'Sí',
        'No',
      ],
    }
  }

  if(step === 2 && userResponse === 'Sí'){
    return [{
      message: '¡Bien! Puede ser útil prestar atención a cómo se comporta su hijo en casa. Sin embargo, no todos los signos de dolor son obvios. ¡Echa un vistazo a nuestros consejos aquí! <a href="#" data-href="/contents/43">más información</a>',
    }, {
      message: '¿Está interesado en aprender acerca de una escala que puede usar para medir el dolor de su hijo?',
      options: [
        'Sí',
        'No',
      ],
    }]
  }

  if(step === 2 && userResponse === 'No'){
    return {
      message: '¿Está interesado en aprender acerca de una escala que puede usar para medir el dolor de su hijo?',
      options: [
        'Sí',
        'No',
      ],
    }
  }

  if(step === 1 && userResponse === 'Sí'){
    return [{
      message: '¡Lo tienes! 👍',
      
    }, {
      message: '¿Está interesado en aprender a detectar el dolor de su hijo?',
      options: [
        'Sí',
        'No',
      ],
    }]
  }

  if(step === 3 && userResponse === 'No'){
    return {
      message: '¿Está interesado en aprender sobre la frecuencia de los analgésicos?',
      options: [
        'Sí',
        'No',
      ],
    }
  }

  if(step === 3 && userResponse === 'Sí'){
    return [{
      message: 'Los proveedores de atención médica usan la escala FACES para comprender el dolor del niño.',
      
    }, {
      message: '<img src="https://s3-us-west-1.amazonaws.com/uci-images/images/chatbot/chatbot-pain.png"/>',
      
    }, {
      message: 'También puede usar esto para medir cuánto dolor está teniendo su hijo. Puede pedirle a su hijo que señale la cara que mejor coincida con cómo se siente.',
    }, {
      message: 'Para obtener más información sobre la escala FACES, haga clic <a href="#" data-href="/contents/42">aquí.</a>',
    }, {
      message: '¿Está interesado en aprender sobre la frecuencia de los analgésicos?',
      options: [
        'Sí',
        'No',
      ],
    }]
  }

  if(step === 4 && userResponse === 'No'){
    return {
      purpose: 'specify field',
      message: `¿Listo para seguir adelante?`,
      options: ['Hacer otra cosa'],
    }
  }

  if(step === 4 && userResponse === 'Sí'){
    return [{
      message: '¡Fenomenal! Puede ser una buena idea darle a su hijo analgésicos, o medicamento para el dolor, antes de que el dolor empeore. Haga un plan con su proveedor de atención médica.',
      
    }, {
      message: 'Obtenga más información sobre las dosis de medicamentos para el dolor <a href="#" data-href="/contents/50">aquí</a>.',
    }, {
      delay: 5000,
      purpose: 'specify field',
      message: `¿Listo para seguir adelante?`,
      options: ['Hacer otra cosa'],
    }]
  }
  
  if(userResponse === 'Hacer otra cosa'){
    return {
      purpose: 'specify field',
      message: `¿Algo más con lo que pueda ayudar?`,
      options: [
        'Técnicas de manejo de la ansiedad de los padres',
          'Preguntas frecuentes de los padres',
          'Ideas para distracción',
          'Precauciones de alimentos y bebidas',
          'Proceso de inducción',
          'Consejos en la sala de recuperación',
          'Qué esperar en casa',
          'Cambiar/cancelar el día de la cirugía del niño',
          'Comunicarse con el proveedor de atención médica de su hijo',
          'Contactar al equipo L-WebTIPS',
        ],
    }
  
  }

  if(userResponse === 'Técnicas de manejo de la ansiedad de los padres'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'main',
    }
  }
  if(userResponse === 'Preguntas frecuentes de los padres'){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'parents',
    }
  }

  if(userResponse === 'Ideas para distracción'){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'distraction',
    }
  }

  if(userResponse === 'Precauciones de alimentos y bebidas'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'food',
    }
  }

  if(userResponse === 'Proceso de inducción'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'induction',
    }
  }

  if(userResponse === 'Consejos en la sala de recuperación'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'recovery',
    }
  }

  if(userResponse === 'Qué esperar en casa'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'home',
    }
  }

  if(userResponse === 'Identificar el dolor de su hijo en casa'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'pain',
    }
  }

  if(userResponse === 'Cambiar/cancelar el día de la cirugía del niño'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'dateOfSurgery',
    }
  }

  if(userResponse === 'Comunicarse con el proveedor de atención médica de su hijo'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'contactHealthProvider',
    }
  }

  if(userResponse ==='Contactar al equipo L-WebTIPS'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'contactResearch',
    }
  }
  return {
    purpose: 'specify field',
    catchAll: true,
  }

}

export const dateOfSurgeryFlow = (step: any, userResponse: any) => {

  if(step === 0){
    return {
      message: '¿Esto es para un cambio en el día de la cirugía o para una cancelación? (Nota: Esto no está asociado con la programación de CHOC).',
      options: [
        'Cambio de día de la cirugía',
        'Cancelación de la cirugía',
      ],
    }
  }

  if(step === 1 && userResponse ===  'Cambio de día de la cirugía'){
    return {
      message: '¡Gracias por hacérnoslo saber! ¿Para qué nueva fecha está programada la cirugía de su hijo?',
    }
  }

  if(step === 1 && userResponse ===  'Cancelación de la cirugía'){
    return [{
      message: '¡Gracias! Su respuesta ha sido grabada, y nuestro equipo de investigación se comunicará con usted con información de fin de estudio.',
      sendCancelDateRequest: true,
    }, {
      delay: 5000,
      purpose: 'specify field',
      message: `¿Listo para seguir adelante?`,
      options: ['Hacer otra cosa'],
    }]
  }

  
 
  if(userResponse === 'Hacer otra cosa'){
    return {
      purpose: 'specify field',
      message: `¿Algo más con lo que pueda ayudar?`,
      options: [
        'Técnicas de manejo de la ansiedad de los padres',
        'Preguntas frecuentes de los padres',
        'Ideas para distracción',
        'Precauciones de alimentos y bebidas',
        'Proceso de inducción',
        'Consejos en la sala de recuperación',
        'Qué esperar en casa',
        'Identificar el dolor de su hijo en casa',
        'Comunicarse con el proveedor de atención médica de su hijo',
        'Contactar al equipo L-WebTIPS',
      ],
    }
  
  }

  if(step === 2 && userResponse){
    return [{
      message: '¡Gracias! Su respuesta ha sido enviada a nuestro equipo de investigación. Le enviaremos un correo electrónico con la confirmación sobre el día actualizado de la cirugía de su hijo.',
      sendUpdateDateRequest: true,
      newDate: userResponse,
    }, {
      delay: 5000,
      purpose: 'specify field',
      message: `¿Listo para seguir adelante?`,
      options: ['Hacer otra cosa'],
    }]
  }

  if(userResponse === 'No'){
    return {
      purpose: 'specify field',
      message: `¿Listo para seguir adelante?`,
      options: ['Hacer otra cosa'],
    }
  }




  if(userResponse === 'Técnicas de manejo de la ansiedad de los padres'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'main',
    }
  }
  if(userResponse === 'Preguntas frecuentes de los padres'){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'parents',
    }
  }

  if(userResponse === 'Ideas para distracción'){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'distraction',
    }
  }

  if(userResponse === 'Precauciones de alimentos y bebidas'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'food',
    }
  }

  if(userResponse === 'Proceso de inducción'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'induction',
    }
  }

  if(userResponse === 'Consejos en la sala de recuperación'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'recovery',
    }
  }

  if(userResponse === 'Qué esperar en casa'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'home',
    }
  }

  if(userResponse === 'Identificar el dolor de su hijo en casa'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'pain',
    }
  }

  if(userResponse === 'Cambiar/cancelar el día de la cirugía del niño'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'dateOfSurgery',
    }
  }

  if(userResponse === 'Comunicarse con el proveedor de atención médica de su hijo'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'contactHealthProvider',
    }
  }

  if(userResponse ==='Contactar al equipo L-WebTIPS'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'contactResearch',
    }
  }
  return {
    purpose: 'specify field',
    catchAll: true,
  }
  

}

export const contactHealthProviderFlow = (step: any, userResponse: any) => {

  if(step === 0){
    return {
      message: '¡Hola! Parece que está tratando de comunicarse con el proveedor de atención médica de su hijo. ¿Es eso correcto?.',
      options: [
        'Sí',
        'No',
      ],
    }
  }

  if(step === 1 && userResponse ===  'Sí'){
    return [{
      message: 'Puede buscar el proveedor de atención médica de su hijo usando la barra de búsqueda en el siguiente enlace.',
    }, {
      message: '<a href="https://www.choc.org/find-a-provider/" target="_blank">https://www.choc.org/find-a-provider/</a>',
    }, {
      delay: 5000,
      purpose: 'specify field',
      message: `¿Listo para seguir adelante?`,
      options: ['Hacer otra cosa'],
    }]
      
  }

  
  
  if(userResponse === 'Hacer otra cosa'){
    return {
      purpose: 'specify field',
      message: `¿Algo más con lo que pueda ayudar?`,
      options: [
        'Técnicas de manejo de la ansiedad de los padres',
          'Preguntas frecuentes de los padres',
          'Ideas para distracción',
          'Precauciones de alimentos y bebidas',
          'Proceso de inducción',
          'Consejos en la sala de recuperación',
          'Qué esperar en casa',
          'Identificar el dolor de su hijo en casa',
          'Cambiar/cancelar el día de la cirugía del niño',
          'Contactar al equipo L-WebTIPS',
      ],
    }
  
  }
  if(userResponse === 'No'){
    return {
      purpose: 'specify field',
      message: `¿Listo para seguir adelante?`,
      options: ['Hacer otra cosa'],
    }
  }


  if(userResponse === 'Técnicas de manejo de la ansiedad de los padres'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'main',
    }
  }
  if(userResponse === 'Preguntas frecuentes de los padres'){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'parents',
    }
  }

  if(userResponse === 'Ideas para distracción'){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'distraction',
    }
  }

  if(userResponse === 'Precauciones de alimentos y bebidas'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'food',
    }
  }

  if(userResponse === 'Proceso de inducción'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'induction',
    }
  }

  if(userResponse === 'Consejos en la sala de recuperación'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'recovery',
    }
  }

  if(userResponse === 'Qué esperar en casa'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'home',
    }
  }

  if(userResponse === 'Identificar el dolor de su hijo en casa'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'pain',
    }
  }

  if(userResponse === 'Cambiar/cancelar el día de la cirugía del niño'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'dateOfSurgery',
    }
  }

  if(userResponse === 'Comunicarse con el proveedor de atención médica de su hijo'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'contactHealthProvider',
    }
  }

  if(userResponse ==='Contactar al equipo L-WebTIPS'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'contactResearch',
    }
  }
  return {
    purpose: 'specify field',
    catchAll: true,
  }

}

export const contactResearchFlow = (step: any, userResponse: any) => {

  if(step === 0){
    return {
      message: '¡Hola! Parece que está tratando de ponerse en contacto con nuestro equipo de estudio de investigación. ¿Es eso correcto?',
      options: [
        'Sí',
        'No',
      ],
    }
  }

  if(step === 1 && userResponse ===  'Sí'){
    return [{
      message: '¡Lo tienes! 👍',
    
    },{
      message: 'Puede llamarnos o mandarnos mensaje de lunes a viernes de 8 am a 4 pm al 714-712-0346.',
    }, {
      message: '¡También puede enviarnos un correo electrónico a <a href="mailto:webtips@choc.org">webtips@choc.org</a>!🧑‍💻',
    }, {
      delay: 5000,
      purpose: 'specify field',
      message: `¿Listo para seguir adelante?`,
      options: ['Hacer otra cosa'],
    }]
      
  }

  
  if(userResponse === 'Hacer otra cosa'){
    return {
      purpose: 'specify field',
      message: `¿Algo más con lo que pueda ayudar?`,
      options: [
        'Técnicas de manejo de la ansiedad de los padres',
        'Preguntas frecuentes de los padres',
        'Ideas para distracción',
        'Precauciones de alimentos y bebidas',
        'Proceso de inducción',
        'Consejos en la sala de recuperación',
        'Qué esperar en casa',
        'Identificar el dolor de su hijo en casa',
        'Cambiar/cancelar el día de la cirugía del niño',
        'Comunicarse con el proveedor de atención médica de su hijo',
      ],
    }
  
  }
  if(userResponse === 'No'){
    return {
      purpose: 'specify field',
      message: `¿Listo para seguir adelante?`,
      options: ['Hacer otra cosa'],
    }
  }


  if(userResponse === 'Técnicas de manejo de la ansiedad de los padres'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'main',
    }
  }
  if(userResponse === 'Preguntas frecuentes de los padres'){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'parents',
    }
  }

  if(userResponse === 'Ideas para distracción'){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'distraction',
    }
  }

  if(userResponse === 'Precauciones de alimentos y bebidas'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'food',
    }
  }

  if(userResponse === 'Proceso de inducción'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'induction',
    }
  }

  if(userResponse === 'Consejos en la sala de recuperación'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'recovery',
    }
  }

  if(userResponse === 'Qué esperar en casa'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'home',
    }
  }

  if(userResponse === 'Identificar el dolor de su hijo en casa'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'pain',
    }
  }

  if(userResponse === 'Cambiar/cancelar el día de la cirugía del niño'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'dateOfSurgery',
    }
  }

  if(userResponse === 'Comunicarse con el proveedor de atención médica de su hijo'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'contactHealthProvider',
    }
  }

  if(userResponse ==='Contactar al equipo L-WebTIPS'
  ){
    return {
      purpose: 'specify field',
      message: ``,
      newFlow: 'contactResearch',
    }
  }return {
    purpose: 'specify field',
    catchAll: true,
  }

}


export const steps = {
    'intro': introSteps,
    'secondary': secondaryFlow,
    'main': mainFlowSteps,
    'parents': parentsFaqFlow,
    'distraction': distractionFlow,
    'food': foodFlow,
    'induction': inductionFlow,
    'recovery': recoveryFlow,
    'home': homeFlow,
    'pain': painFlow,
    'dateOfSurgery': dateOfSurgeryFlow,
    'contactHealthProvider': contactHealthProviderFlow,
    'contactResearch': contactResearchFlow,
  }


// WEBPACK FOOTER //
// ./src/organisms/Chatbot/analyzeNextSteps.ts